import script from "./CourseView.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__